import { Context } from 'react';

export declare const WixStyleReactContext: Context<{
  newColorsBranding: boolean;
  newBrandingClass: string;
}>;
